
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Lesion": () => {
return Promise.all(/*  | __federation_expose_Lesion */ [__webpack_require__.e("787"), __webpack_require__.e("486"), __webpack_require__.e("663")]).then(() => (() => (__webpack_require__(2404))));
},
"./Simulation": () => {
return Promise.all(/*  | __federation_expose_Simulation */ [__webpack_require__.e("787"), __webpack_require__.e("863"), __webpack_require__.e("662")]).then(() => (() => (__webpack_require__(3583))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };